export default __webpack_public_path__ + "static/media/yellow.f1bc7a5c.svg";